import React from 'react';
import { useNavigate } from 'react-router-dom';
import s from './UserProfileButton.module.css';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../store/selectors/authSelectors';
import AvatarComponent from '../avatar/AvatarComponent';

const UserProfileButton = () => {
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const handleClick = () => {
        navigate('/settings');
    };
    return (
        <div onClick={handleClick} className={s.container}>
            <AvatarComponent
                avatarUrl={user?.profile_picture ?? ''}
                userName={user?.username || user?.email || ''}
            />
            <p className={s.name}>{user?.name || user?.username || user?.email || ''}</p>
        </div>
    );
};

export default UserProfileButton;
